<birdz-card
  [isEmpty]="(hasPerimeter$ | async) !== true || !availableTechnos.includes((techno$ | async) ?? '')"
  [isLoading]="isLoading > 0"
>
  <div card-title>{{ 'TAB_KPI_MAP' | transloco }}</div>
  <div card-empty>
    {{
      (!availableTechnos.includes((techno$ | async) ?? '')
        ? 'NOT_AVAILABLE_FOR_SELECTED_TECHNO'
        : 'PLEASE_SELECT_A_CONTRACT'
      ) | transloco
    }}
  </div>
  <div card-body class="body">
    <!-- Rich option template for the meter geocoder — defined here so it has access to component state -->
    <ng-template #meterOptionTpl let-opt>
      <div class="option">
        @if (isBirdzAdmin$ | async) {
          <div class="option__pds">{{ opt.id }}</div>
        } @else {
          <div class="option__customer_pds">{{ opt.customer_pds_id }}</div>
        }
        <div class="option__meter">{{ 'METER' | transloco }} {{ opt.equipment_id }}</div>
        <div class="option__module">{{ 'DEVICE' | transloco }} {{ opt.device_id }}</div>
      </div>
    </ng-template>

    <div>
      @if (isLoading === 0 && isHeavy && !isLoaded) {
        <div class="heavy-map-display">
          <div>{{ 'HEAVY_MAP_LOADING_INTERRUPTED' | transloco }}</div>
          <button matButton="filled" (click)="forceFetchMap()">
            {{ 'RELOAD' | transloco }}
          </button>
        </div>
      }
    </div>

    @if (hasNonGeocodedPds) {
      <birdz-alert type="warning" icon="warning">
        {{
          ((techno$ | async) === 'watermetering' ? 'MESSAGE_NON_GEOCODED_PDS' : 'MESSAGE_NON_GEOCODED_SEWERIN')
            | transloco
        }}
      </birdz-alert>
    }
    <div class="map">
      <birdz-map
        id="supervision-state-map"
        [markerLayers]="mapLayers"
        [popupComponent]="popupComponent"
        [isLoading]="isLoading > 0"
        [isEmpty]="isLoaded && mapSource.getFeatures().length === 0"
        [extraGeocoders]="extraGeocoders"
        [searchResetToken]="searchVersion"
        [hasLegendMenu]="false"
      />
    </div>
    <div class="legend">
      <!-- exclude WB for non birdz admin -->
      @if ((isBirdzAdmin$ | async) === true) {
        <div
          class="legend__item birdz-admin"
          [class.disabled]="!legendToggleState['WB']"
          style="--color: #e0f4d3"
          (click)="toggleLegendState('WB')"
        >
          {{ 'STATE_WB' | transloco }}
        </div>
      }
      <div
        class="legend__item"
        [class.disabled]="!legendToggleState['NOT_CONNECTED']"
        style="--color: #f7a677"
        (click)="toggleLegendState('NOT_CONNECTED')"
      >
        {{ 'STATE_NOT_CONNECTED' | transloco }}
      </div>
      <div
        class="legend__item"
        [class.disabled]="!legendToggleState['FUNCTIONAL']"
        style="--color: #7ed17c"
        (click)="toggleLegendState('FUNCTIONAL')"
      >
        {{ 'STATE_FUNCTIONAL' | transloco }}
      </div>
      <div
        class="legend__item"
        [class.disabled]="!legendToggleState['NONFUNCTIONAL_HS']"
        style="--color: #95cde8"
        (click)="toggleLegendState('NONFUNCTIONAL_HS')"
      >
        {{ 'STATE_NONFUNCTIONAL_HS' | transloco }}
      </div>
      <div
        class="legend__item"
        [class.disabled]="!legendToggleState['NONFUNCTIONAL_NC']"
        style="--color: #3a4255"
        (click)="toggleLegendState('NONFUNCTIONAL_NC')"
      >
        {{ 'STATE_NONFUNCTIONAL_NC' | transloco }}
      </div>
      @if (hasMarkerWithUnknownState) {
        <div
          class="legend__item"
          [class.disabled]="!legendToggleState['UNKNOWN']"
          style="--color: #aaa"
          (click)="toggleLegendState('UNKNOWN')"
        >
          {{ 'STATE_UNKNOWN' | transloco }}
        </div>
      }
    </div>
  </div>
</birdz-card>
